import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 🔴 Redirect on 401 OR 403
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const currentPath = window.location.pathname;

    if (status === 401 || status === 403 ) {
      localStorage.removeItem("token");
      if (currentPath !== "/login" && !currentPath.includes("/changepassword")) {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default api;
